import {usePanelSearchDebouncedContext} from '../../../state/panelbank/PanelSearchContextProvider';
import {usePanelGenHistoryKeysResultsSearchQuery} from '../../../state/panelGenHistoryKeys/panelGenHistoryKeysStore';
import {useIsNgwEnabled} from '../../../util/rampFeatureFlags/rampFeatureFlags';

export const usePanelSearchUpdatePending = (): boolean => {
  const isNgwEnabled = useIsNgwEnabled();
  const {debouncedSearchQuery} = usePanelSearchDebouncedContext();
  const resultsSearchQuery = usePanelGenHistoryKeysResultsSearchQuery();
  return (
    isNgwEnabled && debouncedSearchQuery.trim() !== resultsSearchQuery.trim()
  );
};
